import { Component, Inject, OnInit } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dialog-confirm-component',
  templateUrl: './dialog-confirm-component.component.html',
  styleUrls: ['./dialog-confirm-component.component.css']
})
export class DialogConfirmComponentComponent implements OnInit {
  dialogMsgModel: any;

  constructor(
    private _router: Router
    , public dialogRef: MdDialogRef<DialogConfirmComponentComponent>, @Inject(MD_DIALOG_DATA) public data: any
  ) { }


  ngOnInit() {
    //modelType:"ERROR"/"SUCCESS"/"CONFIRMATION"/"BROKEN"/"VALIDATION"
    this.dialogMsgModel = {
      modelType: "ERROR",
      msgTitle: 'Oops!',
      msg: null,
      redirectUrl: null,
      showDefaultBtn: true,
      defaultBtnCaption: 'OK',
      isConfirmBox: false,
      confirmBtnCaption: 'Confirm',
      cancelBtnCaption: 'Cancel'
    };
    if (this.data && this.data != null) {
      if (this.data.modelType && this.data.modelType != null) {
        this.dialogMsgModel.modelType = this.data.modelType;
      }
      if (this.data.msgTitle && this.data.msgTitle != null) {
        this.dialogMsgModel.msgTitle = this.data.msgTitle;
      }
      if (this.data.msg && this.data.msg != null) {
        this.dialogMsgModel.msg = this.data.msg;
      }
      if (this.data.redirectUrl && this.data.redirectUrl != null) {
        this.dialogMsgModel.redirectUrl = this.data.redirectUrl;
      }
      if (this.data.showDefaultBtn && this.data.showDefaultBtn != null) {
        this.dialogMsgModel.showDefaultBtn = this.data.showDefaultBtn;
      }
      if (this.data.defaultBtnCaption && this.data.defaultBtnCaption != null) {
        this.dialogMsgModel.defaultBtnCaption = this.data.defaultBtnCaption;
      }
      if (this.data.isConfirmBox && this.data.isConfirmBox != null) {
        this.dialogMsgModel.isConfirmBox = this.data.isConfirmBox;
      }
      if (this.data.confirmBtnCaption && this.data.confirmBtnCaption != null) {
        this.dialogMsgModel.confirmBtnCaption = this.data.confirmBtnCaption;
      }
      if (this.data.cancelBtnCaption && this.data.cancelBtnCaption != null) {
        this.dialogMsgModel.cancelBtnCaption = this.data.cancelBtnCaption;
      }
    }
  }

  // To close the current dialog
  closeDialog() {
    if (this.dialogMsgModel && this.dialogMsgModel.redirectUrl != null && this.dialogMsgModel.redirectUrl != "") {
      this._router.navigate([this.dialogMsgModel.redirectUrl]);
    }
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/dialog-confirm-component/dialog-confirm-component.component.ts